import React from "react";

const Column2 = (props) => {
    return (
        <div className="columns-2">
            {props.children}
        </div>
    )
}

export default Column2;